module.exports = __webpack_public_path__ + "img/img-a90b28.png";